import { cn } from "@/helpers/utils";
import { VariantProps, cva } from "class-variance-authority";
import React from "react";

export const cardHeader = cva("px-4 py-2", {
  variants: {
    variant: {
      primary: "bg-primary text-white",
      secondary: "bg-secondary-500 text-white",
      gray: "bg-gray-50 text-dark",
    },
  },
  defaultVariants: { variant: "primary" },
});

interface CardHeaderProps extends VariantProps<typeof cardHeader> {
  children?: React.ReactNode;
  className?: string;
}

export const CardHeader = ({
  children,
  variant,
  className,
}: CardHeaderProps) => {
  return (
    <div className={cn(cardHeader({ variant }), className)}>{children}</div>
  );
};
